import { ROUTE_TO_NEXT, routeTo } from 'redux-router-kit';
import { addTruthyParamsToUrl, extractParams } from '@zapier/url-utils';
/**
 * This middleware started out as a way to redirect the z/z frontend application
 * to the editor's new NextJS service, but now stands to redirect any "split" page.
 *
 * When a team splits their service out of the monorepo, they may use a subpath
 * to host that service. Example: zapier.com/app/settings
 * We want to make sure the code in z/z does not get rendered for that path,
 * so instead of doing a client-side route change, which does not make any requests
 * back to the domain for assets, it will do a hard refresh to make sure we're
 * getting the correct NextJS assets.
 *
 * Route via a full page refresh if:
 * - the url starts with `/app/editor`
 * - this route was triggered by a link from within zapier.com, not a direct
 *  navigation to a browser URL (ie browser refresh, browser bookmark navigation)
 */
const hardRefreshMiddleware = store => next => action => {
  if (!action || !action.type) {
    return next(action);
  }

  // `action` properties are sometimes null, not undefined, so lodash
  // get doesn't work conveniently, since it returns null instead of
  // the default value in that case. So we're not using _.get here.
  const meta = action.meta || {};
  const url = meta.url || '';
  const params = extractParams(url);

  const settingsInStaging =
    url.startsWith('/app/settings') &&
    window.location.href.includes('zapier-staging.com');

  if (
    !params.redirect &&
    action.type === ROUTE_TO_NEXT &&
    (url.startsWith('/app/editor') || settingsInStaging)
  ) {
    const updatedUrl = addTruthyParamsToUrl(url, {
      redirect: true,
    });

    return store.dispatch(routeTo(updatedUrl, { exit: true }));
  }

  return next(action);
};

export default hardRefreshMiddleware;
